function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * @file image-editor.js
 * @module image-editor
 * @version 1.2.0
 * @author Ben Situ
 * @license MIT
 * @description Lightweight canvas-based image editor with masking/transform/export support.
 *
 * This source file is free software, available under the MIT license.
 * It is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the license files for details.
 */

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD / RequireJS
    define([], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // CommonJS / Node / webpack (target=commonjs)
    module.exports = factory();
  } else {
    // Browser normal <script> method, hanging to the global
    root.ImageEditor = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /**
   * ImageEditor
   * 
   * A lightweight wrapper around fabric.js providing masking, scaling, rotation,
   * merging/export helpers, and UI integrations for image editing.
   *
   * <b>Note:</b> Requires fabric.js (v5.x) to be loaded on the page before use.
   *
   * <pre>
   * Example usage:
   * const editor = new ImageEditor({ canvasWidth: 1024, canvasHeight: 768 });
   * editor.init();
   * </pre>
   *
   * @class ImageEditor
   * @classdesc Fabric.js-based image editor with simple mask, transform, export and UI features.
   *
   * @param {Object} [options={}] - Customization options to override defaults.
   * @param {number} [options.canvasWidth=800] - The initial canvas width in pixels.
   * @param {number} [options.canvasHeight=600] - The initial canvas height in pixels.
   * @param {string} [options.backgroundColor='transparent'] - The canvas background color.
   * @param {number} [options.animationDuration=300] - Duration in ms for scale/rotate animations.
   * @param {number} [options.minScale=0.1] - Minimum image scaling factor.
   * @param {number} [options.maxScale=5.0] - Maximum image scaling factor.
   * @param {number} [options.scaleStep=0.05] - Scale increment/decrement per step.
   * @param {number} [options.rotationStep=90] - Rotation step in degrees.
   * @param {boolean} [options.expandCanvasToImage=true] - If true, expands the canvas to fit image/mask.
   * @param {boolean} [options.fitImageToCanvas=false] - If true, fits loaded image inside canvas.
   * @param {boolean} [options.coverImageToCanvas=false] - If true, scales image to cover canvas (at least one side fits, allowing overflow).
   * @param {boolean} [options.downsampleOnLoad=true] - Whether to downsample very large images on load.
   * @param {number} [options.downsampleMaxWidth=4000] - Max width for downsampling.
   * @param {number} [options.downsampleMaxHeight=3000] - Max height for downsampling.
   * @param {number} [options.downsampleQuality=0.92] - JPEG quality for downsampling/export.
   * @param {number} [options.exportMultiplier=1] - Scale output image by this multiplier on export.
   * @param {boolean} [options.exportImageAreaByDefault=true] - Export only the image area (clipped to masks).
   * @param {number} [options.defaultMaskWidth=50] - Default width of new mask rectangles.
   * @param {number} [options.defaultMaskHeight=80] - Default height of new masks.
   * @param {boolean} [options.maskRotatable=false] - If true, masks can be rotated.
   * @param {boolean} [options.maskLabelOnSelect=true] - Show label on selected mask.
   * @param {number} [options.maskLabelOffset=3] - Offset for mask labels from top-left corner.
   * @param {string} [options.maskName='mask'] - Prefix for mask names/labels.
   * @param {boolean} [options.showPlaceholder=true] - If true, shows placeholder when no image is loaded.
   * @param {string|null} [options.initialImageBase64=null] - Base64 string to auto-load as initial image, if any.
   * @param {string} [options.defaultDownloadFileName='edited_image.jpg'] - Default file name for downloads.
   * @param {function} [options.onImageLoaded] - Optional callback to invoke after an image loads.
   * 
   * @constructor
   */
  var ImageEditor = /*#__PURE__*/function () {
    function ImageEditor() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, ImageEditor);
      // Verify that fabric.js is present
      this._fabricLoaded = typeof fabric !== 'undefined';
      if (!this._fabricLoaded) {
        console.error('fabric.js is not loaded. Please include fabric.js first. Initialization will be aborted.');
      }
      // Default options (can be overridden via ctor param)
      this.options = _objectSpread({
        canvasWidth: 800,
        canvasHeight: 600,
        backgroundColor: 'transparent',
        animationDuration: 300,
        minScale: 0.1,
        maxScale: 5.0,
        scaleStep: 0.05,
        rotationStep: 90,
        expandCanvasToImage: true,
        fitImageToCanvas: false,
        coverImageToCanvas: false,
        downsampleOnLoad: true,
        downsampleMaxWidth: 4000,
        downsampleMaxHeight: 3000,
        downsampleQuality: 0.92,
        exportMultiplier: 1,
        exportImageAreaByDefault: true,
        defaultMaskWidth: 50,
        defaultMaskHeight: 80,
        maskRotatable: false,
        maskLabelOnSelect: true,
        maskLabelOffset: 3,
        maskName: 'mask',
        groupSelection: false,
        showPlaceholder: true,
        initialImageBase64: null,
        // Provide a base64 'data:image/...' string here if you want auto-load

        defaultDownloadFileName: 'edited_image.jpg'
      }, options);
      this.options.label = {
        getText: function getText(mask, maskIndex) {
          return mask.maskName;
        },
        textOptions: {
          fontSize: 12,
          fill: '#fff',
          backgroundColor: 'rgba(0,0,0,0.7)',
          padding: 2,
          fontFamily: "monospace",
          fontWeight: "bold",
          selectable: false,
          evented: false,
          originX: 'left',
          originY: 'top'
        }
      };
      this.options.crop = {
        minWidth: 100,
        minHeight: 100,
        padding: 10,
        hideMasksDuringCrop: true,
        preserveMasksAfterCrop: true,
        allowRotationOfCropRect: false
      };

      // Runtime state
      this.canvas = null;
      this.canvasEl = null;
      this.containerEl = null;
      this.placeholderEl = null;
      this.originalImage = null; // fabric.Image
      this.baseImageScale = 1;
      this.currentScale = 1;
      this.currentRotation = 0;
      this.maskCounter = 0;
      this.isAnimating = false;
      this.elements = {};
      this.isImageLoadedToCanvas = false;
      this.maxHistorySize = 50;
      this._boundHandlers = {};
      this._lastMaskInitialLeft = null;
      this._lastMaskInitialTop = null;
      this._lastMaskInitialWidth = null;
      this._cropMode = false;
      this._cropRect = null;
      this._cropHandlers = [];
      this.onImageLoaded = typeof options.onImageLoaded === 'function' ? options.onImageLoaded : null;
      this.animQueue = new AnimationQueue();
      this.historyManager = new HistoryManager(this.maxHistorySize);
    }

    /**
     * Initializes the editor, binds to DOM elements, sets up event handlers,
     * and (optionally) loads an initial image.
     * Use this method to set up the editor UI before interacting with it.
     *
     * @param {Object} [idMap={}] - Optional mapping from logical element names to actual DOM element IDs.
     *   Supported keys include: canvas, canvasContainer, imgPlaceholder, scaleRate, rotationLeftInput, rotationRightInput,
     *   rotateLeftBtn, rotateRightBtn, addMaskBtn, removeMaskBtn, removeAllMasksBtn, mergeBtn, downloadBtn, maskList,
     *   zoomInBtn, zoomOutBtn, resetBtn, imageInput. Unknown keys are ignored.
     *
     * @returns {void}
     *
     * @public
     *
     * @example
     * editor.init({
     *   canvas: 'myFabricCanvasId',
     *   downloadBtn: 'myDownloadButtonId'
     * });
     */
    return _createClass(ImageEditor, [{
      key: "init",
      value: function init() {
        var idMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!this._fabricLoaded) return;
        var defaults = {
          canvas: 'fabricCanvas',
          canvasContainer: null,
          // Pass an ID here if you have a scrollable viewport container
          imgPlaceholder: 'imgPlaceholder',
          scaleRate: 'scaleRate',
          rotationLeftInput: 'rotationLeftInput',
          rotationRightInput: 'rotationRightInput',
          rotateLeftBtn: 'rotateLeftBtn',
          rotateRightBtn: 'rotateRightBtn',
          addMaskBtn: 'addMaskBtn',
          removeMaskBtn: 'removeMaskBtn',
          removeAllMasksBtn: 'removeAllMasksBtn',
          mergeBtn: 'mergeBtn',
          downloadBtn: 'downloadBtn',
          maskList: 'maskList',
          zoomInBtn: 'zoomInBtn',
          zoomOutBtn: 'zoomOutBtn',
          resetBtn: 'resetBtn',
          undoBtn: 'undoBtn',
          redoBtn: 'redoBtn',
          imageInput: 'imageInput',
          cropBtn: 'cropBtn',
          applyCropBtn: 'applyCropBtn',
          cancelCropBtn: 'cancelCropBtn'
        };
        this.elements = _objectSpread(_objectSpread({}, defaults), idMap);
        this._initCanvas();
        this._bindEvents();
        this._updateInputs();
        this._updateMaskList();
        this._updateUI();

        // Auto-load initial image if provided
        if (this.options.initialImageBase64) {
          this.loadImage(this.options.initialImageBase64);
        } else {
          this._updatePlaceholderStatus();
        }
      }

      /**
       * Canvas setup helpers
       * @private
       */
    }, {
      key: "_initCanvas",
      value: function _initCanvas() {
        var _this = this;
        var canvasEl = document.getElementById(this.elements.canvas);
        if (!canvasEl) throw new Error('Canvas is not found: ' + this.elements.canvas);
        this.canvasEl = canvasEl;

        // Decide which element acts as "viewport" (for width/height fallback)
        if (this.elements.canvasContainer) {
          var ce = document.getElementById(this.elements.canvasContainer);
          this.containerEl = ce || canvasEl.parentElement;
        } else {
          this.containerEl = canvasEl.parentElement;
        }
        this.placeholderEl = document.getElementById(this.elements.imgPlaceholder) || null;

        // Initial size — take container size if available
        var initialW = this.options.canvasWidth;
        var initialH = this.options.canvasHeight;
        if (this.containerEl) {
          var cw = Math.floor(this.containerEl.clientWidth);
          var ch = Math.floor(this.containerEl.clientHeight);
          if (cw > 0 && ch > 0) {
            initialW = cw;
            initialH = ch;
          }
        }
        this.canvas = new fabric.Canvas(canvasEl, {
          width: initialW,
          height: initialH,
          backgroundColor: this.options.backgroundColor,
          selection: this.options.groupSelection,
          preserveObjectStacking: true
        });

        // Fabric event wiring
        this.canvas.on('selection:created', function (e) {
          return _this._onSelectionChanged(e.selected);
        });
        this.canvas.on('selection:updated', function (e) {
          return _this._onSelectionChanged(e.selected);
        });
        this.canvas.on('selection:cleared', function () {
          return _this._onSelectionChanged([]);
        });
        this.canvas.on('object:moving', function (e) {
          if (e.target && e.target.maskId) _this._syncMaskLabel(e.target);
        });
        this.canvas.on('object:scaling', function (e) {
          if (e.target && e.target.maskId) _this._syncMaskLabel(e.target);
        });
        this.canvas.on('object:rotating', function (e) {
          if (e.target && e.target.maskId) _this._syncMaskLabel(e.target);
        });
        this.canvas.on('object:modified', function (e) {
          if (e.target && e.target.maskId) _this._syncMaskLabel(e.target);
        });

        // Avoid inline-element whitespace artefacts
        this.canvasEl.style.display = 'block';
      }

      /** 
       * DOM / UI bindings
       * @private
       */
    }, {
      key: "_bindEvents",
      value: function _bindEvents() {
        var _this2 = this;
        // Click anywhere on the upload area opens the native file dialog
        this._bindIfExists('uploadArea', 'click', function () {
          var _document$getElementB;
          return (_document$getElementB = document.getElementById(_this2.elements.imageInput)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.click();
        });
        // File-input change
        var inputEl = document.getElementById(this.elements.imageInput);
        if (inputEl) {
          inputEl.addEventListener('change', function (e) {
            var f = e.target.files && e.target.files[0];
            if (f) _this2._loadImageFile(f);
          });
        }
        // Zoom & reset
        this._bindIfExists('zoomInBtn', 'click', function () {
          return _this2.scaleImage(_this2.currentScale + _this2.options.scaleStep);
        });
        this._bindIfExists('zoomOutBtn', 'click', function () {
          return _this2.scaleImage(_this2.currentScale - _this2.options.scaleStep);
        });
        this._bindIfExists('resetBtn', 'click', function () {
          _this2.reset();
        });
        // Mask management
        this._bindIfExists('addMaskBtn', 'click', function () {
          return _this2.addMask();
        });
        this._bindIfExists('removeMaskBtn', 'click', function () {
          return _this2.removeSelectedMask();
        });
        this._bindIfExists('removeAllMasksBtn', 'click', function () {
          return _this2.removeAllMasks();
        });
        // Merge + download
        this._bindIfExists('mergeBtn', 'click', function () {
          return _this2.merge();
        });
        this._bindIfExists('downloadBtn', 'click', function () {
          return _this2.downloadImage();
        });
        // Undo + Redo
        this._bindIfExists('undoBtn', 'click', function () {
          return _this2.undo();
        });
        this._bindIfExists('redoBtn', 'click', function () {
          return _this2.redo();
        });

        // Rotation buttons (step can be overridden by two input fields)
        var rotLeftBtn = document.getElementById(this.elements.rotateLeftBtn);
        var rotRightBtn = document.getElementById(this.elements.rotateRightBtn);
        if (rotLeftBtn) rotLeftBtn.addEventListener('click', function () {
          var el = document.getElementById(_this2.elements.rotationLeftInput);
          var step = _this2.options.rotationStep;
          if (el) {
            var p = parseFloat(el.value);
            if (!isNaN(p)) step = p;
          }
          _this2.rotateImage(_this2.currentRotation - step);
        });
        if (rotRightBtn) rotRightBtn.addEventListener('click', function () {
          var el = document.getElementById(_this2.elements.rotationRightInput);
          var step = _this2.options.rotationStep;
          if (el) {
            var p = parseFloat(el.value);
            if (!isNaN(p)) step = p;
          }
          _this2.rotateImage(_this2.currentRotation + step);
        });

        // Crop bindings (optional: bound only if element IDs exist in elements)
        this._bindIfExists('cropBtn', 'click', function () {
          return _this2.enterCropMode();
        });
        this._bindIfExists('applyCropBtn', 'click', function () {
          _this2.applyCrop().catch(function (e) {
            return console.error('applyCrop failed', e);
          });
        });
        this._bindIfExists('cancelCropBtn', 'click', function () {
          return _this2.cancelCrop();
        });
      }

      /** 
       * Event binding element check
       * 
       * @param {*} event 
       * @param {*} handler 
       * @param {*} key 
       * @private
       */
    }, {
      key: "_bindIfExists",
      value: function _bindIfExists(key, event, handler) {
        var el = document.getElementById(this.elements[key]);
        if (el) {
          el.addEventListener(event, handler);
          this._boundHandlers = this._boundHandlers || {};
          if (!this._boundHandlers[key]) this._boundHandlers[key] = [];
          this._boundHandlers[key].push({
            event: event,
            handler: handler
          });
        }
      }

      /** 
       * Image loading helpers
       * 
       * @param {File} file 
       * @private
       */
    }, {
      key: "_loadImageFile",
      value: function _loadImageFile(file) {
        var _this3 = this;
        if (!file || !file.type.startsWith('image/')) return;
        var reader = new FileReader();
        reader.onload = function (e) {
          return _this3.loadImage(e.target.result);
        };
        reader.onerror = function (e) {
          console.error("[ImageEditor: fileReadError]", e);
        };
        reader.readAsDataURL(file);
      }

      /**
      * Load a base64 encoded image string into fabric.
      * @async
      * @param {String} base64 
      */
    }, {
      key: "loadImage",
      value: (function () {
        var _loadImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(base64) {
          var _this4 = this;
          var imgEl, loadSrc, needResize, ratio, tw, th;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (this._fabricLoaded) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                if (!(!base64 || typeof base64 !== 'string' || !base64.startsWith('data:image/'))) {
                  _context.n = 2;
                  break;
                }
                return _context.a(2);
              case 2:
                this._setPlaceholderVisible(false);
                _context.n = 3;
                return this._createImageElement(base64);
              case 3:
                imgEl = _context.v;
                loadSrc = base64;
                if (this.options.downsampleOnLoad) {
                  needResize = imgEl.naturalWidth > this.options.downsampleMaxWidth || imgEl.naturalHeight > this.options.downsampleMaxHeight;
                  if (needResize) {
                    ratio = Math.min(this.options.downsampleMaxWidth / imgEl.naturalWidth, this.options.downsampleMaxHeight / imgEl.naturalHeight);
                    tw = Math.round(imgEl.naturalWidth * ratio);
                    th = Math.round(imgEl.naturalHeight * ratio);
                    loadSrc = this._resampleImageToDataURL(imgEl, tw, th, this.options.downsampleQuality);
                  }
                }

                // Create fabric.Image from URL
                fabric.Image.fromURL(loadSrc, function (fimg) {
                  _this4.canvas.discardActiveObject();
                  _this4._hideAllMaskLabels();
                  _this4.canvas.clear();
                  _this4.canvas.setBackgroundColor(_this4.options.backgroundColor, _this4.canvas.renderAll.bind(_this4.canvas));
                  fimg.set({
                    originX: 'left',
                    originY: 'top',
                    selectable: false,
                    evented: false
                  });
                  var imgW = fimg.width;
                  var imgH = fimg.height;
                  var minW = _this4.containerEl ? Math.floor(_this4.containerEl.clientWidth || _this4.options.canvasWidth) : _this4.options.canvasWidth;
                  var minH = _this4.containerEl ? Math.floor(_this4.containerEl.clientHeight || _this4.options.canvasHeight) : _this4.options.canvasHeight;
                  if (_this4.options.fitImageToCanvas) {
                    // Fit into current canvas (shrink only) and ensure canvas does not exceed container
                    var cw = Math.max(1, Math.min(_this4.options.canvasWidth, minW) - 1);
                    var ch = Math.max(1, Math.min(_this4.options.canvasHeight, minH) - 1);
                    _this4._setCanvasSizeInt(cw, ch);
                    var fitScale = Math.min(cw / imgW, ch / imgH, 1);
                    fimg.set({
                      left: 0,
                      top: 0
                    });
                    fimg.scale(fitScale);
                    _this4.baseImageScale = fimg.scaleX || 1;
                  } else if (_this4.options.coverImageToCanvas) {
                    // Cover canvas: scale to cover, allowing overflow (at least one side fits)
                    var _cw = Math.max(_this4.options.canvasWidth, minW);
                    var _ch = Math.max(_this4.options.canvasHeight, minH);
                    _this4._setCanvasSizeInt(_cw, _ch);
                    var coverScale = Math.min(1, Math.max(_cw / imgW, _ch / imgH));
                    fimg.set({
                      left: 0,
                      top: 0
                    });
                    fimg.scale(coverScale);
                    _this4.baseImageScale = fimg.scaleX || 1;
                  } else if (_this4.options.expandCanvasToImage) {
                    // Expand canvas so that it fully contains the image
                    var _cw2 = Math.max(minW, Math.floor(imgW));
                    var _ch2 = Math.max(minH, Math.floor(imgH));
                    _this4._setCanvasSizeInt(_cw2, _ch2);
                    fimg.set({
                      left: 0,
                      top: 0
                    });
                    fimg.scale(1);
                    _this4.baseImageScale = 1;
                  } else {
                    // Keep existing canvas size and center the image
                    var _cw3 = Math.max(_this4.options.canvasWidth, minW);
                    var _ch3 = Math.max(_this4.options.canvasHeight, minH);
                    _this4._setCanvasSizeInt(_cw3, _ch3);
                    var _fitScale = Math.min(_cw3 / imgW, _ch3 / imgH, 1);
                    fimg.set({
                      left: 0,
                      top: 0
                    });
                    fimg.scale(_fitScale);
                    _this4.baseImageScale = fimg.scaleX || 1;
                  }
                  // Put the image onto the canvas
                  _this4.originalImage = fimg;
                  _this4.canvas.add(fimg);
                  _this4.canvas.sendToBack(fimg);

                  // Reset mask placement memory
                  _this4._lastMaskInitialLeft = null;
                  _this4._lastMaskInitialTop = null;
                  _this4._lastMaskInitialWidth = null;
                  _this4.maskCounter = 0;
                  _this4.currentScale = 1;
                  _this4.currentRotation = 0;
                  _this4._updateInputs();
                  _this4._updateMaskList();
                  _this4._updateUI();
                  _this4.canvas.renderAll();
                  _this4.isImageLoadedToCanvas = true;
                  if (typeof _this4.onImageLoaded === 'function') {
                    _this4.onImageLoaded();
                  }
                }, {
                  crossOrigin: 'anonymous'
                });
              case 4:
                return _context.a(2);
            }
          }, _callee, this);
        }));
        function loadImage(_x) {
          return _loadImage.apply(this, arguments);
        }
        return loadImage;
      }()
      /**
       * Checks whether there is a loaded image on the current canvas.
       * @returns {boolean} true if loaded, false if not
       */
      )
    }, {
      key: "isImageLoaded",
      value: function isImageLoaded() {
        return !!(this.originalImage && this.originalImage instanceof fabric.Image && this.originalImage.width > 0 && this.originalImage.height > 0);
      }

      /**
       * Creates an HTMLImageElement from a given data URL.
       * 
       * @param {string} dataURL - A data URL representing the image (e.g., "data:image/png;base64,...").
       * @returns {Promise<HTMLImageElement>} A promise that resolves to the created image element when loaded, or rejects on error.
       * @private
       */
    }, {
      key: "_createImageElement",
      value: function _createImageElement(dataURL) {
        return new Promise(function (res, rej) {
          var img = new Image();
          img.onload = function () {
            img.onload = null;
            img.onerror = null;
            res(img);
          };
          img.onerror = function (e) {
            img.onload = null;
            img.onerror = null;
            rej(e);
          };
          img.src = dataURL;
        });
      }

      /**
       * Resamples the given image element to a new width and height and returns the result as a JPEG data URL.
       * 
       * @param {HTMLImageElement} imgEl - The image element to resample.
       * @param {number} w - Target width (in pixels) for the resampled image.
       * @param {number} h - Target height (in pixels) for the resampled image.
       * @param {number} [quality=0.92] - JPEG image quality between 0 and 1 (optional, default 0.92).
       * @returns {string} A data URL representing the resampled image as JPEG.
       * @private
       */
    }, {
      key: "_resampleImageToDataURL",
      value: function _resampleImageToDataURL(imgEl, w, h) {
        var quality = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.92;
        var oc = document.createElement('canvas');
        oc.width = w;
        oc.height = h;
        var ctx = oc.getContext('2d');
        ctx.drawImage(imgEl, 0, 0, imgEl.naturalWidth, imgEl.naturalHeight, 0, 0, w, h);
        return oc.toDataURL('image/jpeg', quality);
      }

      /** 
       * Sets canvas size to integer width and height values to prevent scrollbars due to sub-pixel rendering.
       * Also updates the corresponding style attributes.
       * 
       * @param {number} w - Canvas width (in pixels).
       * @param {number} h - Canvas height (in pixels).
       * @private
       */
    }, {
      key: "_setCanvasSizeInt",
      value: function _setCanvasSizeInt(w, h) {
        var iw = Math.max(1, Math.round(Number(w) || 1));
        var ih = Math.max(1, Math.round(Number(h) || 1));
        // Set fabric internal and also style attributes to keep DOM consistent
        this.canvas.setWidth(iw);
        this.canvas.setHeight(ih);
        if (typeof this.canvas.calcOffset === 'function') this.canvas.calcOffset();
        // Keep DOM element in sync (avoid fractional CSS pixels)
        if (this.canvasEl) {
          this.canvasEl.style.width = iw + 'px';
          this.canvasEl.style.height = ih + 'px';
          this.canvasEl.style.maxWidth = 'none';
        }
      }

      /** 
       * Gets the top-left corner coordinates of the given object.
       * Used for geometry calculations (e.g., scale, rotate).
       * 
       * @param {Object} obj - The object for which to get the top-left coordinates. Should support setCoords and getCoords/getBoundingRect methods.
       * @returns {{x: number, y: number}} The top-left corner point as an object with x and y properties.
       * @private
       */
    }, {
      key: "_getObjectTopLeftPoint",
      value: function _getObjectTopLeftPoint(obj) {
        if (!obj) return {
          x: 0,
          y: 0
        };
        obj.setCoords();
        var coords = typeof obj.getCoords === 'function' ? obj.getCoords() : null;
        if (coords && coords.length) return coords[0];
        var br = obj.getBoundingRect(true, true);
        return {
          x: br.left,
          y: br.top
        };
      }

      /**
       * Sets the object's origin at the specified origin point, keeping a reference point fixed in position.
       * 
       * @param {Object} obj - The object to modify. Should support set, setPositionByOrigin, and setCoords.
       * @param {string} originX - The new originX ("left", "center", "right", etc.).
       * @param {string} originY - The new originY ("top", "center", "bottom", etc.).
       * @param {{x: number, y: number}} refPoint - The point to keep fixed while setting the new origins.
       * @private
       */
    }, {
      key: "_setObjectOriginKeepingPosition",
      value: function _setObjectOriginKeepingPosition(obj, originX, originY, refPoint) {
        if (!obj || !refPoint || !obj.setPositionByOrigin) return;
        obj.set({
          originX: originX,
          originY: originY
        });
        obj.setPositionByOrigin(refPoint, originX, originY);
        obj.setCoords();
      }

      /**
       * Moves the object so its bounding box aligns with the canvas's top-left corner (0, 0).
       * 
       * @param {Object} obj - The object to align.
       * @private
       */
    }, {
      key: "_alignObjectBoundingBoxToCanvasTopLeft",
      value: function _alignObjectBoundingBoxToCanvasTopLeft(obj) {
        if (!obj) return;
        obj.setCoords();
        var br = obj.getBoundingRect(true, true);
        var dx = br.left;
        var dy = br.top;
        obj.set({
          left: (obj.left || 0) - dx,
          top: (obj.top || 0) - dy
        });
        obj.setCoords();
        this.canvas.renderAll();
      }

      /**
       * Updates the canvas size to match the bounding box of the original image,
       * ensuring that the canvas is always at least as large as its container.
       * @private
       */
    }, {
      key: "_updateCanvasSizeToImageBounds",
      value: function _updateCanvasSizeToImageBounds() {
        if (!this.originalImage) return;
        this.originalImage.setCoords();
        var br = this.originalImage.getBoundingRect(true, true);

        // Container integer sizes
        var containerW = this.containerEl ? Math.ceil(this.containerEl.clientWidth || 0) : 0;
        var containerH = this.containerEl ? Math.ceil(this.containerEl.clientHeight || 0) : 0;

        // If image smaller or equal than container in BOTH dims => keep canvas equal to container
        if (containerW > 0 && containerH > 0 && br.width <= containerW && br.height <= containerH) {
          this._setCanvasSizeInt(containerW, containerH);
          return;
        }

        // Else canvas follows image bounding box but not smaller than container dims individually
        var newW = Math.max(containerW || 0, Math.floor(br.width));
        var newH = Math.max(containerH || 0, Math.floor(br.height));
        this._setCanvasSizeInt(newW, newH);
      }

      /** 
       * Scales the original image by a given factor, with animation.
       * Returns a promise that resolves when the scale animation is complete.
       * @param {number} factor - The scaling factor (will be clamped between `options.minScale` and `options.maxScale`).
       * @returns {Promise<void>} Promise that resolves once the scaling animation finishes.
       * @public
       */
    }, {
      key: "scaleImage",
      value: function scaleImage(factor) {
        var _this5 = this;
        return this.animQueue.add(function () {
          return _this5._scaleImageImpl(factor);
        });
      }

      /** 
       * Scales the original image by a given factor, with animation.
       * Returns a promise that resolves when the scale animation is complete.
       * @param {number} factor - The scaling factor (will be clamped between `options.minScale` and `options.maxScale`).
       * @returns {Promise<void>} Promise that resolves once the scaling animation finishes.
       * @private
       */
    }, {
      key: "_scaleImageImpl",
      value: function _scaleImageImpl(factor) {
        var _this6 = this;
        if (!this.originalImage) return Promise.resolve();
        if (this.isAnimating) return Promise.resolve();
        factor = Math.max(this.options.minScale, Math.min(this.options.maxScale, factor));
        this.currentScale = factor;
        this.isAnimating = true;
        this._updateUI();
        var targetAbs = this.baseImageScale * factor;

        // Scale around current top-left (recompute)
        var topLeft = this._getObjectTopLeftPoint(this.originalImage);
        this._setObjectOriginKeepingPosition(this.originalImage, 'left', 'top', topLeft);
        var p1 = new Promise(function (res) {
          _this6.originalImage.animate('scaleX', targetAbs, {
            duration: _this6.options.animationDuration,
            onChange: _this6.canvas.renderAll.bind(_this6.canvas),
            onComplete: res
          });
        });
        var p2 = new Promise(function (res) {
          _this6.originalImage.animate('scaleY', targetAbs, {
            duration: _this6.options.animationDuration,
            onChange: _this6.canvas.renderAll.bind(_this6.canvas),
            onComplete: res
          });
        });
        return Promise.all([p1, p2]).then(function () {
          _this6.originalImage.set({
            scaleX: targetAbs,
            scaleY: targetAbs
          });
          _this6.originalImage.setCoords();
          if (_this6.options.expandCanvasToImage) _this6._updateCanvasSizeToImageBounds();
          _this6._alignObjectBoundingBoxToCanvasTopLeft(_this6.originalImage);

          // Sync mask labels
          _this6.canvas.getObjects().forEach(function (o) {
            if (o.maskId) _this6._syncMaskLabel(o);
          });
          _this6.isAnimating = false;
          _this6._updateInputs();
          _this6._updateUI();
          _this6.saveState();
        }).catch(function () {
          _this6.isAnimating = false;
          _this6._updateUI();
        });
      }

      /** 
       * Rotates the original image by a given number of degrees, with animation.
       * Returns a promise that resolves when the rotation animation is complete.
       * @param {number} degrees - The angle in degrees to rotate the image.
       * @returns {Promise<void>} Promise that resolves once the rotation animation finishes.
       * @public
       */
    }, {
      key: "rotateImage",
      value: function rotateImage(deg) {
        var _this7 = this;
        return this.animQueue.add(function () {
          return _this7._rotateImageImpl(deg);
        });
      }

      /** 
       * Rotates the original image by a given number of degrees, with animation.
       * Returns a promise that resolves when the rotation animation is complete.
       * @param {number} degrees - The angle in degrees to rotate the image.
       * @returns {Promise<void>} Promise that resolves once the rotation animation finishes.
       * @private
       */
    }, {
      key: "_rotateImageImpl",
      value: function _rotateImageImpl(degrees) {
        var _this8 = this;
        if (!this.originalImage) return Promise.resolve();
        if (this.isAnimating) return Promise.resolve();
        if (isNaN(degrees)) return Promise.resolve();
        this.currentRotation = degrees;
        this.isAnimating = true;
        this._updateUI();
        var center = this.originalImage.getCenterPoint();
        this._setObjectOriginKeepingPosition(this.originalImage, 'center', 'center', center);
        var p = new Promise(function (res) {
          _this8.originalImage.animate('angle', degrees, {
            duration: _this8.options.animationDuration,
            onChange: _this8.canvas.renderAll.bind(_this8.canvas),
            onComplete: res
          });
        });
        return p.then(function () {
          _this8.originalImage.set('angle', degrees);
          _this8.originalImage.setCoords();
          if (_this8.options.expandCanvasToImage) _this8._updateCanvasSizeToImageBounds();
          _this8._alignObjectBoundingBoxToCanvasTopLeft(_this8.originalImage);
          var newTopLeft = _this8._getObjectTopLeftPoint(_this8.originalImage);
          _this8._setObjectOriginKeepingPosition(_this8.originalImage, 'left', 'top', newTopLeft);

          // Sync mask labels
          _this8.canvas.getObjects().forEach(function (o) {
            if (o.maskId) _this8._syncMaskLabel(o);
          });
          _this8.isAnimating = false;
          _this8._updateInputs();
          _this8._updateUI();
          _this8.saveState();
        }).catch(function () {
          _this8.isAnimating = false;
          _this8._updateUI();
        });
      }

      /**
       * Resets the image: scales to 1 and rotates to 0 degrees.
       * @returns {Promise<void>} Promise that resolves when reset is complete.
       */
    }, {
      key: "reset",
      value: function reset() {
        var _this9 = this;
        if (!this.originalImage) return Promise.resolve();
        return this.scaleImage(1).then(function () {
          return _this9.rotateImage(0);
        }).then(function () {
          _this9.saveState();
        }).catch(function (err) {
          console.error('reset() failed', err);
        });
      }

      /**
       * Restores a canvas state that was previously stored by saveState().
       * @param {string} jsonString - the JSON string returned by fabric.toJSON().
       */
    }, {
      key: "loadFromState",
      value: function loadFromState(jsonString) {
        var _this0 = this;
        if (!jsonString || !this.canvas) return;
        try {
          var json = typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
          this.canvas.loadFromJSON(json, function () {
            _this0._hideAllMaskLabels();
            var objs = _this0.canvas.getObjects();
            _this0.originalImage = objs.find(function (o) {
              return o.type === 'image' && !o.maskId;
            }) || null;
            _this0.originalImage.set({
              originX: 'left',
              originY: 'top',
              selectable: false,
              evented: false,
              hasControls: false,
              hoverCursor: 'default'
            });
            _this0.canvas.sendToBack(_this0.originalImage);
            var masks = objs.filter(function (o) {
              return o.maskId;
            });
            _this0.maskCounter = masks.reduce(function (max, m) {
              return Math.max(max, m.maskId);
            }, 0);
            _this0.canvas.renderAll();
            _this0._updateMaskList();
            _this0._updateUI();
          });
        } catch (e) {
          console.error('loadFromState() failed', e);
        }
      }

      /**
       * Saves the current state of the canvas to history, storing any mask/raster label information.
       */
    }, {
      key: "saveState",
      value: function saveState() {
        var _this1 = this;
        if (!this.canvas) return;
        var activeObj = this.canvas.getActiveObject();
        this._hideAllMaskLabels();
        try {
          // request JSON including the custom flag 'isCropRect' so we can filter it out
          var jsonObj = this.canvas.toJSON(['maskId', 'maskName', 'isCropRect']);
          if (Array.isArray(jsonObj.objects)) {
            // filter out crop-rect objects before stringifying
            jsonObj.objects = jsonObj.objects.filter(function (o) {
              return !o.isCropRect;
            });
          }
          var after = JSON.stringify(jsonObj);
          var before = this._lastSnapshot || after;
          var executedOnce = false;
          var cmd = new Command(function () {
            if (executedOnce) {
              _this1.loadFromState(after);
            }
            executedOnce = true;
          }, function () {
            _this1.loadFromState(before);
          });
          this.historyManager.execute(cmd);
          this._lastSnapshot = after;
          if (activeObj && activeObj.maskId) {
            this._showLabelForMask(activeObj);
          }
          this._updateUI();
        } catch (err) {
          console.warn('saveState: failed to save canvas snapshot', err);
        }
      }

      /**
       * Undo the last state change, if possible.
       */
    }, {
      key: "undo",
      value: function undo() {
        this.historyManager.undo();
      }

      /**
       * Redo the next state change, if possible.
       */
    }, {
      key: "redo",
      value: function redo() {
        this.historyManager.redo();
      }

      /** 
       * Adds a rectangular mask to the canvas.
       * Mask placement and properties are determined by the provided config and instance options.
       * Canvas and list UI are updated accordingly.
       * @param {Object} [config={}] - Optional mask configuration overrides:
       *   @param {string} [config.shape='rect'] - 'rect', 'circle', 'ellipse', 'polygon', ...
       *   @param {Object|Array} [config.points] - Required for polygon: [{x, y}, ...] or [[x, y], ...]
       *   @param {number|function} [config.width/height/rx/ry/radius] - Can be number or function(canvas, options) 
       *   @param {number|string|function} [config.left/top] - Absolute, %, or function
       *   @param {number|string} [config.angle] - Rotation angle (degree)
       *   @param {string} [config.color] - Fill color in CSS color format (default 'rgba(0,0,0,0.5)')
       *   @param {number} [config.alpha] - Opacity, from 0 to 1 (default 0.5)
       *   @param {boolean} [config.selectable=true]
       *   @param {Object} [config.styles] - Custom styles (stroke, dashArray, etc)
       *   @param {function} [config.onCreate] - Callback after mask created (receives Fabric object)
       *   @param {function} [config.fabricGenerator] - (cfg) => new FabricObj
       * @returns {fabric.Rect|null} The created mask object, or null if canvas is not available.
       * @public
       */
    }, {
      key: "addMask",
      value: function addMask() {
        var _this10 = this;
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!this.canvas) return null;
        var shapeType = config.shape || 'rect';
        // Default config
        var cfg = _objectSpread({
          shape: shapeType,
          width: this.options.defaultMaskWidth,
          height: this.options.defaultMaskHeight,
          color: 'rgba(0,0,0,0.5)',
          alpha: 0.5,
          gap: 5,
          left: undefined,
          top: undefined,
          angle: 0,
          selectable: true
        }, config);

        // Always start placement relative to canvas left/top.
        var firstOffset = 10;
        var left = firstOffset;
        var top = firstOffset;
        var resolveValue = function resolveValue(val, fallback) {
          if (typeof val === 'function') return val(_this10.canvas, _this10.options); // This context is this of addMask
          if (typeof val === 'string' && val.endsWith('%')) {
            var percent = parseFloat(val) / 100;
            return Math.floor((_this10.canvas ? _this10.canvas.getWidth() : 0) * percent);
          }
          return val != null ? val : fallback;
        };
        if (cfg.left === undefined && this._lastMask) {
          var _prev$top;
          var prev = this._lastMask;
          var prevRight = prev.left;
          if (prev.getScaledWidth) {
            prevRight += prev.getScaledWidth();
          } else if (prev.width) {
            var _prev$scaleX;
            prevRight += prev.width * ((_prev$scaleX = prev.scaleX) !== null && _prev$scaleX !== void 0 ? _prev$scaleX : 1);
          }
          left = Math.round(prevRight + cfg.gap);
          top = (_prev$top = prev.top) !== null && _prev$top !== void 0 ? _prev$top : firstOffset;
        } else {
          left = resolveValue(cfg.left, firstOffset);
          top = resolveValue(cfg.top, firstOffset);
        }
        cfg.width = resolveValue(cfg.width, this.options.defaultMaskWidth);
        cfg.height = resolveValue(cfg.height, this.options.defaultMaskHeight);

        // If expandCanvasToImage mode, ensure canvas large enough to hold mask initial placement
        if (this.options.expandCanvasToImage && shapeType === 'rect') {
          var requiredW = Math.ceil(left + cfg.width + 10);
          var requiredH = Math.ceil(top + cfg.height + 10);
          var minW = this.containerEl ? Math.floor(this.containerEl.clientWidth || 0) : 0;
          var minH = this.containerEl ? Math.floor(this.containerEl.clientHeight || 0) : 0;
          var newW = Math.max(this.canvas.getWidth(), minW, requiredW);
          var newH = Math.max(this.canvas.getHeight(), minH, requiredH);
          this._setCanvasSizeInt(newW, newH);
        }
        var mask;
        if (typeof cfg.fabricGenerator === 'function') {
          mask = cfg.fabricGenerator(cfg, this.canvas, this.options);
        } else {
          switch (shapeType) {
            case 'circle':
              mask = new fabric.Circle(_objectSpread({
                left: left,
                top: top,
                radius: resolveValue(cfg.radius, Math.min(cfg.width, cfg.height) / 2),
                fill: cfg.color,
                opacity: cfg.alpha,
                angle: cfg.angle
              }, cfg.styles));
              break;
            case 'ellipse':
              mask = new fabric.Ellipse(_objectSpread({
                left: left,
                top: top,
                rx: resolveValue(cfg.rx, cfg.width / 2),
                ry: resolveValue(cfg.ry, cfg.height / 2),
                fill: cfg.color,
                opacity: cfg.alpha,
                angle: cfg.angle
              }, cfg.styles));
              break;
            case 'polygon':
              var polyPoints = cfg.points || [];
              if (Array.isArray(polyPoints) && polyPoints.length && _typeof(polyPoints[0]) === 'object') {
                // Ensure numeric {x,y} objects for fabric.Polygon
                polyPoints = polyPoints.map(function (pt) {
                  return {
                    x: Number(pt.x),
                    y: Number(pt.y)
                  };
                });
              }
              mask = new fabric.Polygon(polyPoints, _objectSpread({
                left: left,
                top: top,
                fill: cfg.color,
                opacity: cfg.alpha,
                angle: cfg.angle
              }, cfg.styles));
              break;
            case 'rect':
            default:
              mask = new fabric.Rect(_objectSpread({
                left: left,
                top: top,
                width: resolveValue(cfg.width, this.options.defaultMaskWidth),
                height: resolveValue(cfg.height, this.options.defaultMaskHeight),
                fill: cfg.color,
                opacity: cfg.alpha,
                angle: cfg.angle,
                rx: cfg.rx,
                // Rounded Corners
                ry: cfg.ry
              }, cfg.styles));
          }
        }
        mask.selectable = cfg.selectable !== false;
        mask.hasControls = 'hasControls' in cfg ? cfg.hasControls : true;
        mask.lockRotation = !this.options.maskRotatable;
        mask.borderColor = cfg.borderColor || 'red';
        mask.cornerColor = cfg.cornerColor || 'black';
        mask.cornerSize = cfg.cornerSize || 8;
        mask.transparentCorners = 'transparentCorners' in cfg ? cfg.transparentCorners : false;
        mask.stroke = cfg.styles && cfg.styles.stroke || '#ccc';
        mask.strokeWidth = cfg.styles && cfg.styles.strokeWidth || 1;
        mask.strokeUniform = 'strokeUniform' in cfg ? cfg.strokeUniform : true;
        if (cfg.styles && cfg.styles.strokeDashArray) mask.strokeDashArray = cfg.styles.strokeDashArray;
        mask.originalAlpha = cfg.alpha;
        var normalStyle = {
          stroke: mask.stroke,
          strokeWidth: mask.strokeWidth,
          opacity: mask.originalAlpha
        };
        var hoverStyle = {
          stroke: '#ff5500',
          strokeWidth: 2,
          opacity: Math.min(mask.originalAlpha + 0.2, 1)
        };
        mask.on('mouseover', function () {
          mask.set(hoverStyle);
          mask.canvas.requestRenderAll();
        });
        mask.on('mouseout', function () {
          mask.set(normalStyle);
          mask.canvas.requestRenderAll();
        });

        // Remember initial for next one
        this._lastMaskInitialLeft = left;
        this._lastMaskInitialTop = top;
        this._lastMaskInitialWidth = resolveValue(cfg.width, this.options.defaultMaskWidth);
        mask.maskId = ++this.maskCounter;
        mask.maskName = "".concat(this.options.maskName).concat(mask.maskId);
        this._lastMask = mask;
        this.canvas.add(mask);
        this.canvas.bringToFront(mask);
        if (cfg.selectable) this.canvas.setActiveObject(mask);
        this._onSelectionChanged([mask]);
        this._updateMaskList();
        this._updateUI();
        this.canvas.renderAll();
        this.saveState();
        if (typeof cfg.onCreate === 'function') cfg.onCreate(mask, this.canvas);
        return mask;
      }

      /**
       * Removes the currently selected mask from the canvas, if any.
       * The associated label is also removed. UI and mask list are updated.
       */
    }, {
      key: "removeSelectedMask",
      value: function removeSelectedMask() {
        var active = this.canvas.getActiveObject();
        if (!active || !active.maskId) return;
        this._removeLabelForMask(active);
        this.canvas.remove(active);
        this.canvas.discardActiveObject();
        this._updateMaskList();
        this._updateUI();
        this.canvas.renderAll();
        this.saveState();
      }

      /**
       * Removes all masks from the canvas, including their labels.
       * UI and internal mask placement memory are reset.
       */
    }, {
      key: "removeAllMasks",
      value: function removeAllMasks() {
        var _this11 = this;
        var masks = this.canvas.getObjects().filter(function (o) {
          return o.maskId;
        });
        masks.forEach(function (m) {
          return _this11._removeLabelForMask(m);
        });
        masks.forEach(function (m) {
          return _this11.canvas.remove(m);
        });
        this.canvas.discardActiveObject();
        this._lastMaskInitialLeft = null;
        this._lastMaskInitialTop = null;
        this._lastMaskInitialWidth = null;
        this._updateMaskList();
        this._updateUI();
        this.canvas.renderAll();
        this.saveState();
      }

      /**
       * Removes the label associated with the specified mask object, if it exists.
       * 
       * @param {fabric.Object} mask - The mask object whose label should be removed.
       * @private
       */
    }, {
      key: "_removeLabelForMask",
      value: function _removeLabelForMask(mask) {
        if (!mask || !this.canvas) return;
        if (mask.__label) {
          try {
            var objs = this.canvas.getObjects();
            if (objs.includes(mask.__label)) {
              this.canvas.remove(mask.__label);
            }
          } catch (e) {/* ignore */}
          try {
            delete mask.__label;
          } catch (e) {}
        }
      }

      /**
       * Creates and adds a custom label (fabric.Text or fabric.IText) for the mask.
       * The label is default bound to the top-left of the mask and managed as a non-interactive overlay.
       * 
       * @param {fabric.Object} mask - The mask to create a label for.
       * @private
       */
    }, {
      key: "_createLabelForMask",
      value: function _createLabelForMask(mask) {
        if (!mask || !this.options.maskLabelOnSelect) return;
        this._removeLabelForMask(mask);
        var textObj = null;
        if (this.options.label && typeof this.options.label.create === 'function') {
          textObj = this.options.label.create(mask, fabric);
        }
        if (!textObj) {
          var txt = mask.maskName; // Default
          var textOptions = {
            left: 0,
            top: 0,
            fontSize: 12,
            fill: '#fff',
            backgroundColor: 'rgba(0,0,0,0.7)',
            selectable: false,
            evented: false,
            padding: 2,
            originX: 'left',
            originY: 'top'
          };
          if (this.options.label) {
            if (typeof this.options.label.getText === 'function') {
              txt = this.options.label.getText(mask, this.maskCounter);
            }
            // Merge external styles
            if (this.options.label.textOptions) {
              Object.assign(textOptions, this.options.label.textOptions);
            }
          }
          textObj = new fabric.Text(txt, textOptions);
        }
        textObj.maskLabel = true;
        mask.__label = textObj;
        this.canvas.add(textObj);
        this.canvas.bringToFront(textObj);
        this._syncMaskLabel(mask);
      }

      /**
       * Hides (removes) all mask labels from the canvas.
       * Internal label references on mask objects are also deleted.
       * @private
       */
    }, {
      key: "_hideAllMaskLabels",
      value: function _hideAllMaskLabels() {
        var _this12 = this;
        if (!this.canvas) return;
        var objs = this.canvas.getObjects();
        var labels = objs.filter(function (o) {
          return o.maskLabel;
        });
        labels.forEach(function (l) {
          try {
            if (objs.includes(l)) _this12.canvas.remove(l);
          } catch (e) {}
        });
        objs.forEach(function (o) {
          if (o.maskId && o.__label) {
            try {
              delete o.__label;
            } catch (e) {}
          }
        });
      }

      /**
       * Synchronizes the position, angle, and visibility of the mask's label so that it appears properly above the mask.
       * 
       * @param {fabric.Object} mask - The mask whose label should be repositioned.
       * @private
       */
    }, {
      key: "_syncMaskLabel",
      value: function _syncMaskLabel(mask) {
        var _this$options$maskLab;
        if (!mask) return;
        if (!this.options.maskLabelOnSelect) return;
        if (!mask.__label) return;
        var coords = mask.getCoords ? mask.getCoords() : null;
        if (!coords || coords.length < 4) return;
        var tl = coords[0];
        var center = mask.getCenterPoint();
        var vx = center.x - tl.x;
        var vy = center.y - tl.y;
        var dist = Math.sqrt(vx * vx + vy * vy) || 1;
        var ux = vx / dist;
        var uy = vy / dist;
        var offset = Math.max(0, (_this$options$maskLab = this.options.maskLabelOffset) !== null && _this$options$maskLab !== void 0 ? _this$options$maskLab : 3);
        var px = tl.x + ux * offset;
        var py = tl.y + uy * offset;
        mask.__label.set({
          left: Math.round(px),
          top: Math.round(py),
          angle: mask.angle || 0,
          originX: 'left',
          originY: 'top',
          visible: true
        });
        mask.__label.setCoords();
        this.canvas.renderAll();
      }

      /**
       * Shows the label for the given mask, creating it if necessary and synchronizing its position.
       * 
       * @param {fabric.Object} mask - The mask whose label should be shown.
       * @private
       */
    }, {
      key: "_showLabelForMask",
      value: function _showLabelForMask(mask) {
        if (!mask) return;
        if (!this.options.maskLabelOnSelect) return;
        if (!mask.__label) this._createLabelForMask(mask);
        mask.__label.visible = true;
        this._syncMaskLabel(mask);
      }

      /**
       * Handles changes to the selection of canvas objects (masks),
       * updates mask stroke and label display, and syncs mask list selection.
       *
       * @param {Array<Object>} selected - The currently selected objects (e.g. [mask] or []).
       * @private
       */
    }, {
      key: "_onSelectionChanged",
      value: function _onSelectionChanged(selected) {
        var _this13 = this;
        var selectedMask = (selected || []).find(function (o) {
          return o.maskId;
        });
        var masks = this.canvas.getObjects().filter(function (o) {
          return o.maskId;
        });
        masks.forEach(function (m) {
          if (m !== selectedMask) {
            if (m.__label) {
              try {
                _this13.canvas.remove(m.__label);
              } catch (e) {}
              delete m.__label;
            }
            m.set({
              stroke: '#ccc',
              strokeWidth: 1
            });
          } else {
            m.set({
              stroke: '#ff0000',
              strokeWidth: 1
            });
          }
        });
        if (selectedMask) this._showLabelForMask(selectedMask);
        this._updateMaskListSelection(selectedMask);
        this.canvas.renderAll();
        this._updateUI();
      }

      /**
       * Updates the mask list in the DOM to reflect the current masks on the canvas.
       * Each list entry becomes a clickable element for mask selection.
       * @private
       */
    }, {
      key: "_updateMaskList",
      value: function _updateMaskList() {
        var _this14 = this;
        var listEl = document.getElementById(this.elements.maskList);
        if (!listEl) return;
        listEl.innerHTML = '';
        var masks = this.canvas.getObjects().filter(function (o) {
          return o.maskId;
        });
        masks.forEach(function (mask) {
          var li = document.createElement('li');
          li.className = 'list-group-item mask-item';
          li.textContent = mask.maskName;
          li.onclick = function () {
            _this14.canvas.setActiveObject(mask);
            _this14._onSelectionChanged([mask]);
          };
          listEl.appendChild(li);
        });
      }

      /**
       * Updates the visual selection (CSS 'active') state for the mask list in the DOM.
       * 
       * @param {Object|null} selectedMask - The currently selected mask, or null if none selected.
       * @private
       */
    }, {
      key: "_updateMaskListSelection",
      value: function _updateMaskListSelection(selectedMask) {
        var listEl = document.getElementById(this.elements.maskList);
        if (!listEl) return;
        var items = listEl.querySelectorAll('.mask-item');
        items.forEach(function (item) {
          var isSelected = !!selectedMask && item.textContent === selectedMask.maskName;
          item.classList.toggle('active', isSelected);
        });
      }

      /**
       * Merges current masks into the image: exports a masked/cropped image, removes all masks, and re-imports the merged image.
       * Will not run if no original image or no masks exist.
       * @async
       * @returns {Promise<void>} Resolves when merge and load are complete.
       */
    }, {
      key: "merge",
      value: (function () {
        var _merge = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var masks, merged, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (this.originalImage) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                masks = this.canvas.getObjects().filter(function (o) {
                  return o.maskId;
                });
                if (masks.length) {
                  _context2.n = 2;
                  break;
                }
                return _context2.a(2);
              case 2:
                this.canvas.discardActiveObject();
                this.canvas.renderAll();
                _context2.p = 3;
                _context2.n = 4;
                return this.getImageBase64({
                  exportImageArea: true,
                  multiplier: this.options.exportMultiplier
                });
              case 4:
                merged = _context2.v;
                this.removeAllMasks();
                _context2.n = 5;
                return this.loadImage(merged);
              case 5:
                this.saveState();
                _context2.n = 7;
                break;
              case 6:
                _context2.p = 6;
                _t = _context2.v;
                console.error('merge error', _t);
                if (this.canvasEl) this.canvasEl.style.visibility = '';
              case 7:
                return _context2.a(2);
            }
          }, _callee2, this, [[3, 6]]);
        }));
        function merge() {
          return _merge.apply(this, arguments);
        }
        return merge;
      }()
      /**
       * Triggers a JPEG image download of the current canvas (image plus masks if configured).
       * The image area and multiplier are controlled by options.
       * @param {string} [fileName=this.options.defaultDownloadFileName] - Desired download file name.
       */
      )
    }, {
      key: "downloadImage",
      value: function downloadImage() {
        var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.defaultDownloadFileName;
        if (!this.originalImage) return;
        var exportImageArea = this.options.exportImageAreaByDefault;
        this.getImageBase64({
          exportImageArea: exportImageArea,
          multiplier: this.options.exportMultiplier
        }).then(function (base64) {
          var link = document.createElement('a');
          link.download = fileName;
          link.href = base64;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(function (err) {
          return console.error('download error', err);
        });
      }

      /**
       * Exports the image as a Base64-encoded JPEG.
       * Can export either the original, or the current view including masks (clipped/cropped).
       * Will restore masks' state after temporary modifications for export.
       * @async
       * @param {Object} [opts={}] - Export options.
       * @param {boolean} [opts.exportImageArea] - If true, exports only the image bounding area with masks cropped and blended.
       * @param {number} [opts.multiplier=1] - Scaling multiplier for output (resolution).
       * @returns {Promise<string>} Promise resolving to a JPEG image data URL.
       * @throws {Error} If there is no image loaded.
       */
    }, {
      key: "getImageBase64",
      value: (function () {
        var _getImageBase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          var _this15 = this;
          var opts,
            exportImageArea,
            multiplier,
            imgEl,
            w,
            h,
            oc,
            ctx,
            masks,
            masksBackup,
            imgBr,
            sx,
            sy,
            sw,
            sh,
            finalBase64,
            _args3 = arguments;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                opts = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                if (this.originalImage) {
                  _context3.n = 1;
                  break;
                }
                throw new Error('No image loaded');
              case 1:
                exportImageArea = typeof opts.exportImageArea === 'boolean' ? opts.exportImageArea : this.options.exportImageAreaByDefault;
                multiplier = opts.multiplier || this.options.exportMultiplier || 1;
                if (exportImageArea) {
                  _context3.n = 3;
                  break;
                }
                // Export original image pixels
                imgEl = this.originalImage.getElement ? this.originalImage.getElement() : this.originalImage._element || null;
                if (imgEl) {
                  _context3.n = 2;
                  break;
                }
                return _context3.a(2, this.canvas.toDataURL({
                  format: 'jpeg',
                  quality: this.options.downsampleQuality,
                  multiplier: multiplier
                }));
              case 2:
                w = this.originalImage.width;
                h = this.originalImage.height;
                oc = document.createElement('canvas');
                oc.width = w;
                oc.height = h;
                ctx = oc.getContext('2d');
                ctx.drawImage(imgEl, 0, 0, w, h);
                return _context3.a(2, oc.toDataURL('image/jpeg', this.options.downsampleQuality));
              case 3:
                // Export current scaled image area (masks clipped)
                masks = this.canvas.getObjects().filter(function (o) {
                  return o.maskId;
                });
                masksBackup = masks.map(function (m) {
                  return {
                    obj: m,
                    opacity: m.opacity,
                    fill: m.fill,
                    strokeWidth: m.strokeWidth,
                    stroke: m.stroke,
                    selectable: m.selectable,
                    lockRotation: m.lockRotation
                  };
                }); // Remove labels, deselect
                masks.forEach(function (m) {
                  return _this15._removeLabelForMask(m);
                });
                this.canvas.discardActiveObject();
                this.canvas.renderAll();

                // Set masks to opaque black no border
                masks.forEach(function (m) {
                  m.set({
                    opacity: 1,
                    fill: '#000000',
                    strokeWidth: 0,
                    stroke: null,
                    selectable: false
                  });
                  m.setCoords();
                });
                this.canvas.renderAll();

                // Compute integer bounding box for image
                this.originalImage.setCoords();
                imgBr = this.originalImage.getBoundingRect(true, true);
                sx = Math.max(0, Math.round(imgBr.left));
                sy = Math.max(0, Math.round(imgBr.top));
                sw = Math.max(1, Math.round(imgBr.width));
                sh = Math.max(1, Math.round(imgBr.height)); // Crop precisely in offscreen canvas
                _context3.n = 4;
                return new Promise(function (resolve, reject) {
                  try {
                    var fullDataUrl = _this15.canvas.toDataURL({
                      format: 'jpeg',
                      quality: _this15.options.downsampleQuality,
                      multiplier: multiplier
                    });
                    var img = new Image();
                    img.onload = function () {
                      try {
                        var sxM = Math.round(sx * multiplier);
                        var syM = Math.round(sy * multiplier);
                        var swM = Math.round(sw * multiplier);
                        var shM = Math.round(sh * multiplier);
                        var _oc = document.createElement('canvas');
                        _oc.width = swM;
                        _oc.height = shM;
                        var _ctx = _oc.getContext('2d');
                        _ctx.drawImage(img, sxM, syM, swM, shM, 0, 0, swM, shM);
                        var out = _oc.toDataURL('image/jpeg', _this15.options.downsampleQuality);
                        resolve(out);
                      } catch (e) {
                        reject(e);
                      }
                    };
                    img.onerror = reject;
                    img.src = fullDataUrl;
                  } catch (e) {
                    reject(e);
                  }
                });
              case 4:
                finalBase64 = _context3.v;
                // Restore masks
                masksBackup.forEach(function (b) {
                  try {
                    b.obj.set({
                      opacity: b.opacity,
                      fill: b.fill,
                      strokeWidth: b.strokeWidth,
                      stroke: b.stroke,
                      selectable: b.selectable,
                      lockRotation: b.lockRotation
                    });
                    b.obj.setCoords();
                  } catch (e) {}
                });
                this.canvas.renderAll();
                return _context3.a(2, finalBase64);
            }
          }, _callee3, this);
        }));
        function getImageBase64() {
          return _getImageBase.apply(this, arguments);
        }
        return getImageBase64;
      }()
      /**
       * Exports the current canvas (with or without masks) as a File object.
       * Allows you to choose whether to merge masks and specify file type (jpeg/png/webp).
       * 
       * @async
       * @param {Object} [opts={}] - Export options.
       * @param {boolean} [opts.mergeMask=true] - If true, export image area with masks merged; if false, export the plain image without masks.
       * @param {string} [opts.fileType='jpeg'] - Output file type ('jpeg' | 'png' | 'webp'). Defaults to 'jpeg' on invalid input.
       * @param {number} [opts.quality=0.92] - Image quality for lossy types (0-1, default based on options.downsampleQuality).
       * @param {number} [opts.multiplier=1] - Output resolution multiplier.
       * @param {string} [opts.fileName] - Optional file name (only used for download).
       * @returns {Promise<File>} Resolves with the exported image as a File object.
       * 
       * @example
       *   const file = await this.exportImageFile({ mergeMask: false, fileType: 'png' });
       */
      )
    }, {
      key: "exportImageFile",
      value: (function () {
        var _exportImageFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var _this$options$downsam, _this$options$exportM, _this$options$default;
          var opts,
            _opts$mergeMask,
            mergeMask,
            _opts$fileType,
            fileType,
            _opts$quality,
            quality,
            _opts$multiplier,
            multiplier,
            _opts$fileName,
            fileName,
            typeMapping,
            safeFileType,
            base64,
            imageDataUrl,
            bstr,
            mime,
            n,
            u8arr,
            file,
            _args4 = arguments;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                opts = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
                if (this.originalImage) {
                  _context4.n = 1;
                  break;
                }
                throw new Error('No image loaded');
              case 1:
                _opts$mergeMask = opts.mergeMask, mergeMask = _opts$mergeMask === void 0 ? true : _opts$mergeMask, _opts$fileType = opts.fileType, fileType = _opts$fileType === void 0 ? 'jpeg' : _opts$fileType, _opts$quality = opts.quality, quality = _opts$quality === void 0 ? (_this$options$downsam = this.options.downsampleQuality) !== null && _this$options$downsam !== void 0 ? _this$options$downsam : 0.92 : _opts$quality, _opts$multiplier = opts.multiplier, multiplier = _opts$multiplier === void 0 ? (_this$options$exportM = this.options.exportMultiplier) !== null && _this$options$exportM !== void 0 ? _this$options$exportM : 1 : _opts$multiplier, _opts$fileName = opts.fileName, fileName = _opts$fileName === void 0 ? (_this$options$default = this.options.defaultDownloadFileName) !== null && _this$options$default !== void 0 ? _this$options$default : 'exported_image.jpg' : _opts$fileName;
                typeMapping = {
                  'jpeg': 'jpeg',
                  'jpg': 'jpeg',
                  'image/jpeg': 'jpeg',
                  'png': 'png',
                  'image/png': 'png',
                  'webp': 'webp',
                  'image/webp': 'webp'
                };
                safeFileType = typeMapping[String(fileType).toLowerCase()] || 'jpeg'; // Get Base64
                if (!mergeMask) {
                  _context4.n = 3;
                  break;
                }
                _context4.n = 2;
                return this.getImageBase64({
                  exportImageArea: true,
                  multiplier: multiplier
                });
              case 2:
                base64 = _context4.v;
                _context4.n = 5;
                break;
              case 3:
                _context4.n = 4;
                return this.getImageBase64({
                  exportImageArea: false,
                  multiplier: multiplier
                });
              case 4:
                base64 = _context4.v;
              case 5:
                // Convert to the required image format
                imageDataUrl = base64;
                if (imageDataUrl.startsWith("data:image/".concat(safeFileType))) {
                  _context4.n = 7;
                  break;
                }
                _context4.n = 6;
                return new Promise(function (resolve, reject) {
                  var img = new window.Image();
                  img.crossOrigin = "Anonymous";
                  img.onload = function () {
                    try {
                      var oc = document.createElement('canvas');
                      oc.width = img.width;
                      oc.height = img.height;
                      var ctx = oc.getContext('2d');
                      ctx.drawImage(img, 0, 0);
                      var durl = oc.toDataURL("image/".concat(safeFileType), quality);
                      resolve(durl);
                    } catch (e) {
                      reject(e);
                    }
                  };
                  img.onerror = reject;
                  img.src = base64;
                });
              case 6:
                imageDataUrl = _context4.v;
              case 7:
                // Convert DataURL to Blob and then to File
                bstr = atob(imageDataUrl.split(',')[1]);
                mime = "image/".concat(safeFileType);
                n = bstr.length;
                u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                file = new File([u8arr], fileName, {
                  type: mime
                });
                return _context4.a(2, file);
            }
          }, _callee4, this);
        }));
        function exportImageFile() {
          return _exportImageFile.apply(this, arguments);
        }
        return exportImageFile;
      }()
      /**
       * Enter crop mode: create a resizable/movable selection rect on top of the image.
       * @public
       */
      )
    }, {
      key: "enterCropMode",
      value: function enterCropMode() {
        var _this16 = this;
        if (!this.canvas || !this.originalImage || this._cropMode) return;
        if (!this.isImageLoaded()) return;
        this._cropMode = true;

        // Disable canvas group selection to avoid accidental group selection while cropping
        this._prevSelectionSetting = this.canvas.selection;
        this.canvas.selection = false;

        // Make sure no active object
        this.canvas.discardActiveObject();

        // Create initial crop rect centered on the image bounding box
        this.originalImage.setCoords();
        var imgBr = this.originalImage.getBoundingRect(true, true);
        // Provide small inset so user can see a margin
        var padding = this.options.crop && this.options.crop.padding ? this.options.crop.padding : 10;
        var left = Math.max(0, Math.floor(imgBr.left + padding));
        var top = Math.max(0, Math.floor(imgBr.top + padding));
        var width = Math.min(this.options.crop.minWidth || 50, Math.floor(imgBr.width - padding * 2));
        var height = Math.min(this.options.crop.minHeight || 50, Math.floor(imgBr.height - padding * 2));

        // Visual style: translucent fill + dashed stroke
        var cropRect = new fabric.Rect({
          left: left,
          top: top,
          width: width,
          height: height,
          fill: 'rgba(0,0,0,0.12)',
          stroke: '#00aaff',
          strokeDashArray: [6, 4],
          strokeWidth: 1,
          strokeUniform: true,
          selectable: true,
          hasRotatingPoint: !!(this.options.crop && this.options.crop.allowRotationOfCropRect),
          lockRotation: !(this.options.crop && this.options.crop.allowRotationOfCropRect),
          cornerSize: 8,
          objectCaching: false,
          originX: 'left',
          originY: 'top'
        });

        // Ensure the crop rect is above everything
        this.canvas.add(cropRect);
        cropRect.isCropRect = true;
        this.canvas.bringToFront(cropRect);
        this.canvas.setActiveObject(cropRect);

        // Keep reference
        this._cropRect = cropRect;

        // While in crop mode: we want only the cropRect to be interactive
        // but still allow moving/scaling it. To be safe, set other objects evented=false temporarily.
        this._cropPrevEvented = [];
        this.canvas.getObjects().forEach(function (o) {
          if (o !== cropRect) {
            _this16._cropPrevEvented.push({
              obj: o,
              evented: o.evented,
              selectable: o.selectable
            });
            try {
              o.evented = false;
              o.selectable = false;
            } catch (e) {/* ignore */}
          }
        });

        // When the crop rect changes, re-render
        var onModified = function onModified() {
          try {
            cropRect.setCoords();
            _this16.canvas.requestRenderAll();
          } catch (e) {}
        };
        cropRect.on('modified', onModified);
        cropRect.on('moving', onModified);
        cropRect.on('scaling', onModified);

        // Keep handlers to remove later
        this._cropHandlers.push({
          target: cropRect,
          handlers: [{
            evt: 'modified',
            fn: onModified
          }, {
            evt: 'moving',
            fn: onModified
          }, {
            evt: 'scaling',
            fn: onModified
          }]
        });
        this._updateUI();
        this.canvas.renderAll();
      }

      /**
       * Cancel crop mode and remove the temporary selection rect.
       * @public
       */
    }, {
      key: "cancelCrop",
      value: function cancelCrop() {
        if (!this.canvas || !this._cropMode) return;
        // Remove handlers if any and remove object
        if (this._cropRect) {
          try {
            if (this._cropHandlers && this._cropHandlers.length) {
              this._cropHandlers.forEach(function (h) {
                h.handlers.forEach(function (rec) {
                  return h.target.off(rec.evt, rec.fn);
                });
              });
            }
          } catch (e) {/* ignore */}
          try {
            this.canvas.remove(this._cropRect);
          } catch (e) {}
          this._cropRect = null;
        }
        // restore evented/selectable flags
        if (Array.isArray(this._cropPrevEvented)) {
          this._cropPrevEvented.forEach(function (i) {
            try {
              i.obj.evented = i.evented;
              i.obj.selectable = i.selectable;
            } catch (e) {}
          });
        }
        this._cropPrevEvented = null;
        this._cropHandlers = [];
        this._cropMode = false;
        // restore selection setting
        this.canvas.selection = !!this._prevSelectionSetting;
        this._prevSelectionSetting = undefined;
        this.canvas.discardActiveObject();
        this._updateUI();
        this.canvas.renderAll();
      }

      /**
       * Apply the current crop rectangle.
       * remove all masks and export canvas snapshot and crop via offscreen canvas
       * @public
       */
    }, {
      key: "applyCrop",
      value: (function () {
        var _applyCrop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          var _this17 = this;
          var rectBounds, sx, sy, sw, sh, beforeJson, jsonObj, masks, croppedBase64, fullDataUrl, afterJson, jsonObj2, _self, cmd, _t2, _t3;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.p = _context5.n) {
              case 0:
                if (!(!this.canvas || !this._cropMode || !this._cropRect)) {
                  _context5.n = 1;
                  break;
                }
                return _context5.a(2);
              case 1:
                // Ensure crop rect coords are fresh
                this._cropRect.setCoords();
                rectBounds = this._cropRect.getBoundingRect(true, true); // Compute integer crop region clamped to canvas
                sx = Math.max(0, Math.round(rectBounds.left));
                sy = Math.max(0, Math.round(rectBounds.top));
                sw = Math.max(1, Math.round(Math.min(rectBounds.width, this.canvas.getWidth() - sx)));
                sh = Math.max(1, Math.round(Math.min(rectBounds.height, this.canvas.getHeight() - sy))); // Include isCropRect in toJSON whitelist so we can detect and filter them out.
                beforeJson = null;
                try {
                  jsonObj = this.canvas.toJSON(['maskId', 'maskName', 'isCropRect']);
                  if (Array.isArray(jsonObj.objects)) {
                    jsonObj.objects = jsonObj.objects.filter(function (o) {
                      return !o.isCropRect;
                    });
                  }
                  beforeJson = JSON.stringify(jsonObj);
                } catch (e) {
                  console.warn('applyCrop: could not serialize before state', e);
                  beforeJson = null;
                }

                // Remove ALL un-merged masks so they won't be baked into exported pixels
                try {
                  masks = this.canvas.getObjects().filter(function (o) {
                    return o.maskId;
                  });
                  if (masks && masks.length) {
                    masks.forEach(function (m) {
                      try {
                        _this17._removeLabelForMask(m);
                        _this17.canvas.remove(m);
                      } catch (err) {
                        console.warn('applyCrop: failed to remove mask', err);
                      }
                    });
                    this.canvas.discardActiveObject();
                    this.canvas.renderAll();
                  }
                } catch (e) {
                  console.warn('applyCrop: error while removing masks', e);
                }
                try {
                  if (this._cropRect) {
                    try {
                      if (this._cropHandlers && this._cropHandlers.length) {
                        this._cropHandlers.forEach(function (h) {
                          h.handlers.forEach(function (rec) {
                            return h.target.off(rec.evt, rec.fn);
                          });
                        });
                      }
                    } catch (e) {/* ignore */}
                    try {
                      this.canvas.remove(this._cropRect);
                    } catch (e) {/* ignore */}
                    this._cropRect = null;
                  }
                } catch (e) {/* ignore */}

                // End crop mode
                this._cropMode = false;
                this.canvas.selection = !!this._prevSelectionSetting;
                this._prevSelectionSetting = undefined;

                // Export full canvas and crop on offscreen canvas
                _context5.p = 2;
                fullDataUrl = this.canvas.toDataURL({
                  format: 'jpeg',
                  quality: this.options.downsampleQuality || 0.92,
                  multiplier: 1
                });
                _context5.n = 3;
                return new Promise(function (resolve, reject) {
                  var img = new Image();
                  img.onload = function () {
                    try {
                      var oc = document.createElement('canvas');
                      oc.width = sw;
                      oc.height = sh;
                      var ctx = oc.getContext('2d');
                      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
                      var out = oc.toDataURL('image/jpeg', _this17.options.downsampleQuality || 0.92);
                      resolve(out);
                    } catch (err) {
                      reject(err);
                    }
                  };
                  img.onerror = function (e) {
                    return reject(e);
                  };
                  img.src = fullDataUrl;
                });
              case 3:
                croppedBase64 = _context5.v;
                _context5.n = 5;
                break;
              case 4:
                _context5.p = 4;
                _t2 = _context5.v;
                console.error('applyCrop: failed to create cropped image', _t2);
                this._updateUI();
                return _context5.a(2);
              case 5:
                _context5.p = 5;
                _context5.n = 6;
                return this.loadImage(croppedBase64);
              case 6:
                _context5.n = 8;
                break;
              case 7:
                _context5.p = 7;
                _t3 = _context5.v;
                console.error('applyCrop: loadImage(croppedBase64) failed', _t3);
                this._updateUI();
                return _context5.a(2);
              case 8:
                // Create "after" snapshot (also exclude crop rect if any) and push history command
                afterJson = null;
                try {
                  jsonObj2 = this.canvas.toJSON(['maskId', 'maskName', 'isCropRect']);
                  if (Array.isArray(jsonObj2.objects)) {
                    jsonObj2.objects = jsonObj2.objects.filter(function (o) {
                      return !o.isCropRect;
                    });
                  }
                  afterJson = JSON.stringify(jsonObj2);
                } catch (e) {
                  console.warn('applyCrop: failed to serialize after state', e);
                  afterJson = null;
                }
                try {
                  _self = this;
                  cmd = new Command(function () {
                    if (afterJson) _self.loadFromState(afterJson);
                  }, function () {
                    if (beforeJson) _self.loadFromState(beforeJson);
                  });
                  if (!this.historyManager) this.historyManager = new HistoryManager(this.maxHistorySize || 50);

                  // trim future redo history
                  if (this.historyManager.currentIndex < this.historyManager.history.length - 1) {
                    this.historyManager.history = this.historyManager.history.slice(0, this.historyManager.currentIndex + 1);
                  }
                  this.historyManager.history.push(cmd);
                  if (this.historyManager.history.length > this.historyManager.maxSize) {
                    this.historyManager.history.shift();
                  } else {
                    this.historyManager.currentIndex++;
                  }
                } catch (e) {
                  console.warn('applyCrop: failed to push history command', e);
                }

                // Final UI update
                this._updateUI();
                this.canvas.renderAll();
              case 9:
                return _context5.a(2);
            }
          }, _callee5, this, [[5, 7], [2, 4]]);
        }));
        function applyCrop() {
          return _applyCrop.apply(this, arguments);
        }
        return applyCrop;
      }()
      /* ---------- Misc / UI ---------- */
      /**
       * Updates the scale input field in the UI to reflect the current scale.
       * Sets the value (as percentage) if the element is present.
       * @private
       */
      )
    }, {
      key: "_updateInputs",
      value: function _updateInputs() {
        var scaleEl = document.getElementById(this.elements.scaleRate);
        if (scaleEl) scaleEl.value = Math.round(this.currentScale * 100);
      }

      /**
       * Updates the enabled/disabled state of various UI controls (buttons)
       * based on the current application state (image/mask presence, animation, etc).
       * @private
       */
    }, {
      key: "_updateUI",
      value: function _updateUI() {
        var _this$historyManager, _this$historyManager2;
        var hasImg = !!this.originalImage;
        var masks = hasImg ? this.canvas.getObjects().filter(function (o) {
          return o.maskId;
        }) : [];
        var hasMasks = masks.length > 0;
        var active = this.canvas.getActiveObject();
        var hasSelectedMask = active && active.maskId;
        var isDefault = this.currentScale === 1 && this.currentRotation === 0;
        var canUndo = (_this$historyManager = this.historyManager) === null || _this$historyManager === void 0 ? void 0 : _this$historyManager.canUndo();
        var canRedo = (_this$historyManager2 = this.historyManager) === null || _this$historyManager2 === void 0 ? void 0 : _this$historyManager2.canRedo();
        var inCrop = !!this._cropMode;
        if (inCrop) {
          // iterate all element keys and disable unless key is applyCropBtn or cancelCropBtn
          for (var _i = 0, _Object$keys = Object.keys(this.elements || {}); _i < _Object$keys.length; _i++) {
            var k = _Object$keys[_i];
            var el = document.getElementById(this.elements[k]);
            if (!el) continue;
            if (k === 'applyCropBtn' || k === 'cancelCropBtn') {
              el.disabled = false;
            } else {
              el.disabled = true;
            }
          }
          return;
        }
        this._setDisabled('zoomInBtn', !hasImg || this.isAnimating || this.currentScale >= this.options.maxScale);
        this._setDisabled('zoomOutBtn', !hasImg || this.isAnimating || this.currentScale <= this.options.minScale);
        this._setDisabled('rotateLeftBtn', !hasImg || this.isAnimating);
        this._setDisabled('rotateRightBtn', !hasImg || this.isAnimating);
        this._setDisabled('addMaskBtn', !hasImg || this.isAnimating);
        this._setDisabled('removeMaskBtn', !hasSelectedMask || this.isAnimating);
        this._setDisabled('removeAllMasksBtn', !hasMasks || this.isAnimating);
        this._setDisabled('mergeBtn', !hasImg || !hasMasks || this.isAnimating);
        this._setDisabled('downloadBtn', !hasImg || this.isAnimating);
        this._setDisabled('resetBtn', !hasImg || isDefault || this.isAnimating);
        this._setDisabled('undoBtn', !hasImg || this.isAnimating || !canUndo);
        this._setDisabled('redoBtn', !hasImg || this.isAnimating || !canRedo);
        this._setDisabled('cropBtn', !hasImg || this.isAnimating);
        this._setDisabled('applyCropBtn', true);
        this._setDisabled('cancelCropBtn', true);
      }

      /**
       * Enables or disables a specific UI element (typically a button) by its key.
       * 
       * @param {string} key - Key of the element in this.elements (e.g. 'zoomInBtn').
       * @param {boolean} disabled - If true, disables the element; otherwise enables.
       * @private
       */
    }, {
      key: "_setDisabled",
      value: function _setDisabled(key, disabled) {
        var el = document.getElementById(this.elements[key]);
        if (el) el.disabled = !!disabled;
      }

      /**
       * Automatically display and hide placeholders and containers based on the current image content
       * @private
       */
    }, {
      key: "_updatePlaceholderStatus",
      value: function _updatePlaceholderStatus() {
        if (!this.options.showPlaceholder) return;
        this._setPlaceholderVisible(!this.originalImage);
      }

      /**
       * Controls the display/hiding of the Placeholder and Canvas container.
       * @param {boolean} show - true displays the placeholder, false displays the canvas container
       * @private
       */
    }, {
      key: "_setPlaceholderVisible",
      value: function _setPlaceholderVisible(show) {
        if (!this.placeholderEl) return;
        if (show) {
          this.placeholderEl.classList.remove('d-none');
          this.placeholderEl.classList.add('d-flex');
          this.containerEl.classList.add('d-none');
        } else {
          this.placeholderEl.classList.remove('d-flex');
          this.placeholderEl.classList.add('d-none');
          this.containerEl.classList.remove('d-none');
        }
      }

      /**
       * Cleans up and disposes of the canvas and related references.
       * Call this method to free memory and remove canvas listeners when the editor is no longer needed.
       * @public
       */
    }, {
      key: "dispose",
      value: function dispose() {
        var _this18 = this;
        // Remove bound DOM event listeners
        try {
          var _loop = function _loop() {
            var handlers = _this18._boundHandlers[key] || [];
            var el = document.getElementById(_this18.elements[key]);
            if (!el) return 1; // continue
            handlers.forEach(function (h) {
              try {
                el.removeEventListener(h.event, h.handler);
              } catch (e) {}
            });
          };
          for (var key in this._boundHandlers || {}) {
            if (_loop()) continue;
          }
        } catch (e) {}
        if (this._cropRect) {
          try {
            this.canvas.remove(this._cropRect);
          } catch (e) {}
          this._cropRect = null;
        }
        if (this.canvas) {
          try {
            this.canvas.dispose();
          } catch (e) {}
          this.canvas = null;
          this.canvasEl = null;
          this.isImageLoadedToCanvas = false;
        }
        this._boundHandlers = {};
      }
    }]);
  }();
  /**
   * A simple FIFO queue that guarantees animations are executed sequentially.
   * @class AnimationQueue
   */
  var AnimationQueue = /*#__PURE__*/function () {
    /**
     * Creates a new AnimationQueue.
     *
     * @constructor
     */
    function AnimationQueue() {
      _classCallCheck(this, AnimationQueue);
      /**
       * Internal queue holding animation descriptors.
       * @type {Array<{fn: Function, resolve: Function, reject: Function}>}
       */
      this.queue = [];
      /**
       * Flag indicating whether an animation is currently running.
       * @type {boolean}
       */
      this.running = false;
    }

    /**
     * Adds an animation function to the queue.
     *
     * @param   {Function} animationFn  A function that returns a Promise or any await-able.
     * @returns {Promise<*>}            A Promise that resolves/rejects with the animation result.
     */
    return _createClass(AnimationQueue, [{
      key: "add",
      value: (function () {
        var _add = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(animationFn) {
          var _this19 = this;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                return _context6.a(2, new Promise(function (resolve, reject) {
                  // Push the animation into the queue.
                  _this19.queue.push({
                    fn: animationFn,
                    resolve: resolve,
                    reject: reject
                  });
                  // Start processing if it's not already running.
                  if (!_this19.running) {
                    _this19.processQueue();
                  }
                }));
            }
          }, _callee6);
        }));
        function add(_x2) {
          return _add.apply(this, arguments);
        }
        return add;
      }()
      /**
       * Internal helper that processes the animation queue sequentially until it is empty.
       *
       * @private
       * @returns {Promise<void>}
       */
      )
    }, {
      key: "processQueue",
      value: (function () {
        var _processQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          var _this$queue$shift, fn, resolve, reject, result, _t4;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.p = _context7.n) {
              case 0:
                if (!(this.queue.length === 0)) {
                  _context7.n = 1;
                  break;
                }
                this.running = false;
                return _context7.a(2);
              case 1:
                this.running = true;
                _this$queue$shift = this.queue.shift(), fn = _this$queue$shift.fn, resolve = _this$queue$shift.resolve, reject = _this$queue$shift.reject;
                _context7.p = 2;
                _context7.n = 3;
                return fn();
              case 3:
                result = _context7.v;
                resolve(result);
                _context7.n = 5;
                break;
              case 4:
                _context7.p = 4;
                _t4 = _context7.v;
                reject(_t4);
              case 5:
                this.processQueue();
              case 6:
                return _context7.a(2);
            }
          }, _callee7, this, [[2, 4]]);
        }));
        function processQueue() {
          return _processQueue.apply(this, arguments);
        }
        return processQueue;
      }())
    }]);
  }();
  /**
   * Command object encapsulating an executable action and its corresponding undo operation.
   * @class Command
   */
  var Command = /*#__PURE__*/_createClass(
  /**
   * @param {Function} execute  The function that performs the action.
   * @param {Function} undo     The function that reverts the action.
   */
  function Command(execute, undo) {
    _classCallCheck(this, Command);
    /**
     * Executes the command.
     * @type {Function}
     */
    this.execute = execute;
    /**
     * Undoes the command.
     * @type {Function}
     */
    this.undo = undo;
  });
  /**
   * Manages a history of Command objects enabling undo/redo functionality.
   * @class HistoryManager
   */
  var HistoryManager = /*#__PURE__*/function () {
    /**
     * @param {number} [maxSize=50]  Maximum number of commands to keep in history.
     */
    function HistoryManager() {
      var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
      _classCallCheck(this, HistoryManager);
      this.history = [];
      this.currentIndex = -1;
      this.maxSize = maxSize;
    }

    /**
     * Executes a new command and pushes it onto the history stack.
     * Truncates any "future" history when branching.
     *
     * @param {Command} command  The command to execute.
     * @returns {void}
     */
    return _createClass(HistoryManager, [{
      key: "execute",
      value: function execute(command) {
        // Perform the command.
        command.execute();

        // Remove any commands that are ahead of the current index.
        if (this.currentIndex < this.history.length - 1) {
          this.history = this.history.slice(0, this.currentIndex + 1);
        }

        // Add the new command.
        this.history.push(command);

        // Maintain the max size of the buffer.
        if (this.history.length > this.maxSize) {
          this.history.shift(); // Remove the oldest command.
        } else {
          this.currentIndex++;
        }
      }

      /**
       * Checks whether an undo operation is possible.
       *
       * @returns {boolean}  True if undo can be performed.
       */
    }, {
      key: "canUndo",
      value: function canUndo() {
        return this.currentIndex >= 0;
      }

      /**
       * Checks whether a redo operation is possible.
       *
       * @returns {boolean}  True if redo can be performed.
       */
    }, {
      key: "canRedo",
      value: function canRedo() {
        return this.currentIndex < this.history.length - 1;
      }

      /**
       * Undoes the last executed command if possible.
       *
       * @returns {void}
       */
    }, {
      key: "undo",
      value: function undo() {
        if (this.currentIndex >= 0) {
          this.history[this.currentIndex].undo();
          this.currentIndex--;
        }
      }

      /**
       * Redoes the next command in history if possible.
       *
       * @returns {void}
       */
    }, {
      key: "redo",
      value: function redo() {
        if (this.currentIndex < this.history.length - 1) {
          this.currentIndex++;
          this.history[this.currentIndex].execute();
        }
      }
    }]);
  }();
  return ImageEditor;
});